import request from '@/utils/request'

// 获取隐私政策状态
export function getPrivacyStatus() {
  return request({
    url: '/privacy/user',
    method: 'get'
  })
}

// 同意隐私政策
export function agreePrivacy() {
  return request({
    url: '/privacy/agree',
    method: 'post'
  })
}